export default __webpack_public_path__ + "static/internal_and_external_audit-b37df8a26630075af8fb6e85f03e008d.png";